import { REQ_TIRESMIN_SUCCESS } from '../types/tireMinTypes'


const INITIAL_STATE = {
  tiresMin: []
}

export const tiresMinReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case REQ_TIRESMIN_SUCCESS:
      return {
        ...state,
        tiresMin: action.payload
      }
    default:
      return state
  }
}